export default "__VITE_PUBLIC_ASSET__1376adec__"